
import { Component, Vue } from 'vue-property-decorator'
import { ElForm } from 'element-ui/types/form'
import { iFile, parseTime } from '@/common/utils'
import { NewsService } from '@/services'
import FullLoading from '@/components/full_loading/index.vue'
@Component({
    name: 'export-keywords',
    components: {
        FullLoading
    }
})
export default class extends Vue {
    private columns: any[] = []
    private form: any = {
        dateRange: ''
    }
    private keyword = ''
    private startTime: any = ''
    private endTime: any = ''
    private fields: any[] = []
    private keywords: any[] = []
    private keywordError = ''
    private fieldsError = ''
    private checkAll = false
    private isIndeterminate = false
    private loading = false
    private rules = {
        dateRange: [{ required: true, message: '请选择时间段', trigger: 'blur' }]
    }

    get formEl() {
        return this.$refs.form as ElForm
    }

    async mounted() {
        this.loading = true
        await this.getExportColumns()
        this.loading = false
    }

    onCheckKeyword() {
        if (!this.keywords.length) {
            this.keywordError = '请添加关键词'
        } else {
            this.keywordError = ''
        }
    }
    // 选择时间
    onTimeChange() {
        const [startTime, endTime] = this.form.dateRange
        this.startTime = parseTime(startTime, '{y}-{m}-{d}')
        this.endTime = parseTime(endTime, '{y}-{m}-{d}')
    }
    // 全选
    onCheckAllChange(val: any) {
        this.fields = val ? this.columns : []
        this.isIndeterminate = false
        if (this.fields) this.fieldsError = ''
    }
    // 添加关键词
    onAddKeyword() {
        const value = this.keyword.trim()
        if (!value) return
        this.keywordError = ''
        const isInclude = this.isIncludeKeyword(value)
        if (!isInclude) {
            this.keywords.unshift({ id: +Date.now(), name: this.keyword })
            this.keyword = ''
        } else {
            this.$merror('请不要重复添加相同的关键词')
        }
    }
    // 删除关键词
    onDeleteKeyword(keyword: any) {
        const index = this.getIndexOfKeywords(keyword)
        this.keywords.splice(index, 1)
    }
    // 是否已存在
    isIncludeKeyword(value: any) {
        let flag = false
        this.keywords.map((k: any) => {
            if (k.name === value) {
                flag = true
            }
        })
        return flag
    }
    // 获取索引
    getIndexOfKeywords(value: any) {
        return this.keywords.indexOf(value)
    }
    // 字段更改
    onFieldChange(value: any) {
        let checkedCount = value.length
        this.checkAll = checkedCount === this.columns.length
        this.isIndeterminate = checkedCount > 0 && checkedCount < this.columns.length
        if (this.fields.length) this.fieldsError = ''
    }
    // 导出数据
    onExport() {
        this.formEl.validate(valid => {
            const isKwValid = !!this.keywords.length
            const isFieldValid = !!this.fields.length
            this.keywordError = isKwValid ? '' : '请添加关键词'
            this.fieldsError = isFieldValid ? '' : '请选择字段'
            const isAllValid = valid && isKwValid && isFieldValid
            const params = {
                keywords: this.formatKeywords(this.keywords),
                published_at_gte: this.startTime,
                published_at_lte: this.endTime,
                columns: this.fields
            }
            if (isAllValid) {
                this.$confirm('即将导出数据，点击继续可下载文件，是否继续', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(async () => {
                        await this.exportData(params)
                    })
                    .catch(err => {
                        this.$message.error(err.message)
                    })
            }
        })
    }
    // 请求导出数据的base64文件流
    async exportData(params: any) {
        const result = await NewsService.exportNewsData(params)
        if (result.status === 200) {
            const { file_name: fileName, file_data: fileData } = result.data
            if (!fileData) return this.$merror('暂无数据')
            return iFile.downloadBase64File(fileData, fileName)
        }
        this.$merror('发生错误, 请稍后再试')
    }

    // 格式化关键词数组
    formatKeywords(keywords: any[]) {
        let kw: any[] = []
        keywords.map((n: any) => {
            kw.push(n.name)
        })
        return kw
    }
    // 获取支持的字段
    async getExportColumns() {
        const result = await NewsService.getNewsExportColumns({})
        if (result.status === 200) {
            this.columns = result.data
            return
        }
    }

    // 重置
    resetFields() {
        this.formEl.resetFields()
        this.keywords = []
        this.fields = []
        this.keywordError = ''
        this.fieldsError = ''
        this.startTime = ''
        this.endTime = ''
        this.isIndeterminate = false
        this.checkAll = false
    }
}
